import { computed, effect, signal } from '@preact/signals-react'

import { appConfigSignal, appConfigLoadedSignal } from './appConfigSignals.js'
import { userManifestLoadedSignal, userManifestSignal } from './userManifestSignals.js'

import { UserSettingsType } from '../../utils/constants'
import { getDefaultTaskListFilters, getEmptyFilters } from '../../utils/filters'

export const utgListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.UtgListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.UtgListFilters)): getEmptyFilters())
effect(() => {
    if (utgListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.UtgListFilters, JSON.stringify(utgListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.UtgListFilters)
    }
})
export const utgListFiltersCountSignal = computed(() => utgListFiltersValueSignal.value?.Predicates?.length || 0)

export const taskListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.TaskListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.TaskListFilters)): getDefaultTaskListFilters())
effect(() => {
    if (taskListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.TaskListFilters, JSON.stringify(taskListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.TaskListFilters)
    }
})
export const taskListFiltersCountSignal = computed(() => taskListFiltersValueSignal.value?.Predicates?.length || 0)

export const deviceListFiltersValueSignal = signal(window.localStorage.getItem(UserSettingsType.DeviceListFilters) ? JSON.parse(localStorage.getItem(UserSettingsType.DeviceListFilters)) : getEmptyFilters() )
effect(() => {
    if (deviceListFiltersValueSignal.value) {
        window.localStorage.setItem(UserSettingsType.DeviceListFilters, JSON.stringify(deviceListFiltersValueSignal.value))
    }
    else {
        window.localStorage.removeItem(UserSettingsType.DeviceListFilters)
    }
})
export const deviceListFiltersCountSignal = computed(() => deviceListFiltersValueSignal.value?.Predicates?.length || 0)

export const pageSizeSignal = signal(window.localStorage.getItem(UserSettingsType.PageSize) ? parseInt(window.localStorage.getItem(UserSettingsType.PageSize), 10) : 250)
effect(() => {
    window.localStorage.setItem(UserSettingsType.PageSize, pageSizeSignal.value)
})

export const showSidebarSignal = signal(window.localStorage.getItem(UserSettingsType.ShowTree) === 'true')
effect(() => {
    window.localStorage.setItem(UserSettingsType.ShowTree, showSidebarSignal.value)
})

export const sidebarWidthSignal = signal(window.localStorage.getItem(UserSettingsType.SidebarWidth) || 300)
effect(() => {
    window.localStorage.setItem(UserSettingsType.SidebarWidth, sidebarWidthSignal.value)
})

export const debugSignal = signal(window.localStorage.getItem(UserSettingsType.Debug) === 'true')
effect(() => {
    window.localStorage.setItem(UserSettingsType.Debug, debugSignal.value)
})

export const entityProxyModeSignal = signal(window.localStorage.getItem("entityProxyMode") === 'true')
effect(() => {
    window.localStorage.setItem('entityProxyMode', entityProxyModeSignal.value)
})

export const selectedBusinessEntityIdSignal = signal(window.localStorage.getItem(UserSettingsType.SelectedBusinessEntityId))

export const utgColumnConfigSignal = signal(window.localStorage.getItem(UserSettingsType.UtgColumnConfig) ? JSON.parse(window.localStorage.getItem(UserSettingsType.UtgColumnConfig)) : null)
effect(() => {
    if (utgColumnConfigSignal.value) {
        window.localStorage.setItem(UserSettingsType.UtgColumnConfig, JSON.stringify(utgColumnConfigSignal.value))
    } else {
        window.localStorage.removeItem(UserSettingsType.UtgColumnConfig)
    }
})

export const deviceColumnConfigSignal = signal(window.localStorage.getItem(UserSettingsType.DeviceColumnConfig) ? JSON.parse(window.localStorage.getItem(UserSettingsType.DeviceColumnConfig)) : null)
effect(() => {
    if (deviceColumnConfigSignal.value) {
        window.localStorage.setItem(UserSettingsType.DeviceColumnConfig, JSON.stringify(deviceColumnConfigSignal.value))
    } else {
        window.localStorage.removeItem(UserSettingsType.DeviceColumnConfig)
    }
})

export const taskColumnConfigSignal = signal(window.localStorage.getItem(UserSettingsType.TaskColumnConfig) ? JSON.parse(window.localStorage.getItem(UserSettingsType.TaskColumnConfig)) : null)
effect(() => {
    if (taskColumnConfigSignal.value) {
        window.localStorage.setItem(UserSettingsType.TaskColumnConfig, JSON.stringify(taskColumnConfigSignal.value))
    } else {
        window.localStorage.removeItem(UserSettingsType.TaskColumnConfig)
    }
})
effect(() => {
    if (selectedBusinessEntityIdSignal.value) {
        window.localStorage.setItem(UserSettingsType.SelectedBusinessEntityId, selectedBusinessEntityIdSignal.value)
    }
    else {
        window.localStorage.removeItem(UserSettingsType.SelectedBusinessEntityId)
    }
})

export const currentUrlFragmentSignal = signal(null)

export const hasProfileImageComputed = computed(
    () => {
        if (!userManifestLoadedSignal.value) {
            return false
        }
        return userManifestSignal.value && userManifestSignal.value.imageSelected
    }
)

export const profileImageSrcComputed = computed(
    () => {
        if (!appConfigLoadedSignal.value) {
            return null
        }
        if (hasProfileImageComputed.value && appConfigSignal.value.ssoBaseUrl) {
            return `${appConfigSignal.value.ssoBaseUrl}/images/security/${userManifestSignal.value.image}.png`
        }
        return null
    }
)